var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAnnounce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.2,21.8v4.4h8.8v-4.4h-8.8ZM32.8,36.342c2.112,1.562,4.862,3.63,7.04,5.258.88-1.166,1.76-2.354,2.64-3.52-2.178-1.628-4.928-3.696-7.04-5.28-.88,1.188-1.76,2.376-2.64,3.542ZM42.48,9.92c-.88-1.166-1.76-2.354-2.64-3.52-2.178,1.628-4.928,3.696-7.04,5.28.88,1.166,1.76,2.354,2.64,3.52,2.112-1.584,4.862-3.63,7.04-5.28ZM6.4,17.4c-2.42,0-4.4,1.98-4.4,4.4v4.4c0,2.42,1.98,4.4,4.4,4.4h2.2v8.8h4.4v-8.8h2.2l11,6.6V10.8l-11,6.6H6.4ZM31.7,24c0-2.926-1.276-5.566-3.3-7.37v14.718c2.024-1.782,3.3-4.422,3.3-7.348Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnnounce);
export default __webpack_public_path__ + "static/media/icon-announce.55c75d2ed010ddb7a99739da47040217.svg";
export { ForwardRef as ReactComponent };